package ai.wagemix.pages

import ai.wagemix.components.layouts.LocalTopBarActions
import ai.wagemix.di.koin
import ai.wagemix.logic.WMNavigationRequest
import ai.wagemix.navigate
import ai.wagemix.siteStrings
import ai.wagemix.web.screens.picker.WMDefaultOccupationPickerWebViewModel
import ai.wagemix.web.screens.picker.WMOccupationPickerSheet
import ai.wagemix.web.screens.mixbuilder.WMDefaultMixBuilderWebViewModel
import ai.wagemix.web.screens.mixbuilder.WMMixBuilderScreen
import ai.wagemix.web.screens.mixbuilder.WMMixBuilderTopBarActions
import ai.wagemix.web.screens.share.WMDefaultShareMixWebViewModel
import ai.wagemix.web.screens.share.WMShareMixDialog
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import org.koin.core.parameter.parametersOf

@Page(routeOverride = "/mix")
@Layout(".components.layouts.AppShellLayout")
@Composable
fun MixPage(ctx: PageContext) = MixBuilderPage(ctx, mixId = null)

@Page(routeOverride = "/mix/{mixId}")
@Layout(".components.layouts.AppShellLayout")
@Composable
fun StoredMixPage(ctx: PageContext) = MixBuilderPage(ctx, mixId = ctx.route.params["mixId"])

@Composable
private fun MixBuilderPage(ctx: PageContext, mixId: String?) {
    val s = siteStrings
    val nav = { request: WMNavigationRequest -> ctx.navigate(request) }
    val topBarSlot = LocalTopBarActions.current
    var shareMixId by remember { mutableStateOf<String?>(null) }

    WMMixBuilderScreen(
        createViewModel = {
            koin.get<WMDefaultMixBuilderWebViewModel> { parametersOf(mixId ?: "", nav, { id: String -> shareMixId = id }) }
        },
        mixId = mixId,
        strings = s,
        picker = { onClose ->
            WMOccupationPickerSheet(
                createViewModel = { koin.get<WMDefaultOccupationPickerWebViewModel> { parametersOf(onClose) } },
                strings = s,
                onClose = onClose
            )
        },
        topBarActions = { vm ->
            DisposableEffect(vm) {
                topBarSlot.value = { WMMixBuilderTopBarActions(vm, s) }
                onDispose { topBarSlot.value = null }
            }
        }
    )

    shareMixId?.let { id ->
        WMShareMixDialog(
            createViewModel = { koin.get<WMDefaultShareMixWebViewModel> { parametersOf(id, nav) } },
            mixId = id,
            strings = s,
            onClose = { shareMixId = null }
        )
    }
}
